/**
 * Centralized logger. Only outputs in development mode.
 * Replace with Sentry/LogRocket in production.
 */
const isDev = process.env.NODE_ENV === "development";

const logger = {
  error: (msg, ...args) => { if (isDev) console.error(`[GMS] ${msg}`, ...args); },
  warn:  (msg, ...args) => { if (isDev) console.warn(`[GMS] ${msg}`, ...args); },
  info:  (msg, ...args) => { if (isDev) console.info(`[GMS] ${msg}`, ...args); },
};

export default logger;
